<template>
  <!-- SEO s -->
  <title>Hcon</title>
  <meta name="description" content="임직원 선물·이벤트 쿠폰 1분 발송! 간편한 엑셀 업로드로 빠르게 대량 발송하고, 기업 고객을 위한 다양한 혜택까지 만나보세요." />
  <meta name="google-site-verification" content="google-site-verification=AAGbM9J0zOaKfBtCL8SFxmLQ_9z_OHdIzwbHO-U05E8" />
  <meta name="naver-site-verification" content="be858a0bf7beb8b0d2395c05aeb94acfbf9c7a80" />
  <meta name="keywords" content="에이치콘" />
  <meta property="og:title" content="Hcon" />
  <meta property="og:description" content="임직원 선물·이벤트 쿠폰 1분 발송! 간편한 엑셀 업로드로 빠르게 대량 발송하고, 기업 고객을 위한 다양한 혜택까지 만나보세요." />
  <meta property="og:url" content="https://hcon.co.kr" />
  <!-- SEO e -->
  <div v-if="!route.path.startsWith('/view')" class="pc">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    
    <!-- 로그인 전역 팝업 s -->
    <LoginPopup/>
    <!-- 로그인 전역 팝업 e -->

    <!-- admin 딤드 s -->
    <Teleport to="body">
      <Transition name="fade">
        <div v-if="shouldShowAdminDimmed" class="admin-popup-dimmed"></div>
      </Transition>
    </Teleport>
    <!-- admin 딤드 e -->

    <!-- admin 팝업 s -->
    <AdBasePopup v-for="popup in visibleAdminPopups" :key="popup.id" :is-open="isAdminVisible(popup.id)" :title="popup.title" :width="popup.width" :height="popup.height" :content="popup.content" :class="popup.adClass" :showCloseButton="popup.close" @close="closeAdminPopup(popup.id, false)">
      <template #footer>
        <button type="button" @click="closeAdminPopup(popup.id, true)" class="today-button">오늘 그만보기</button>
        <button type="button" @click="closeAdminPopup(popup.id, false)" class="cancel-button">닫기</button>
      </template>
    </AdBasePopup>
    <!-- admin 팝업 e -->
    
    <!-- Alert 팝업 s -->
    <AlertPopup v-model:is-open="isAlertPopupOpen" :data="alertData" @confirm="closeAlert" />
    <!-- Alert 팝업 e -->

    <!-- Confirm 팝업 s -->
    <ConfirmPopup v-model:is-open="isConfirmPopupOpen" :data="confirmData" :showCancelButton="confirmData.showCancelButton" :showEtcButton="confirmData.showEtcButton" :etcText="confirmData.etcText" @confirm="closeConfirm(true)" @cancel="closeConfirm(false)" @etc="handleEtc" />
    <!-- Confirm 팝업 e -->

  </div>
  <!-- 모바일용 (브릿지페이지) 영역 -->
  <div v-else class="mo-bridge">
    <!-- <NuxtPage /> -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script lang="ts">
import { usePopup } from '@/composables/hconUsePopup'
import AlertPopup from '~/components/com/HconComAlertPopup.vue'
import ConfirmPopup from '~/components/com/HconComConfirmPopup.vue'
import AdBasePopup from '@/components/com/HconComAdPopup.vue'
import LoginPopup from "@/pages/pc/member/login/LoginPopup.vue";
import { computed, onMounted, watch, onBeforeUnmount, onBeforeMount, onActivated } from "vue";
import SessionStorageSynchronizer from '~/utils/sync-sessionstorage';
import { fireNaverPageview } from '~/utils/naver/naverConversion';

</script>

<script lang="ts" setup>
// 전역 팝업
const {
  adminPopups,
  isAdminVisible,
  closeAdminPopup,
  setAdminPopups,
  isAlertPopupOpen,
  isConfirmPopupOpen,
  isAnyPopupOpen,
  alertData,
  confirmData,
  isLoggedIn,
  closeAlert,
  closeConfirm,
  handleEtc
} = usePopup()

const { isMobile }  = useDevice();
const route         = useRoute();
watchEffect(() => {
  if (route.meta?.layout === undefined) {
    if (route.path.startsWith('/view')) {
      setPageLayout('mobile');
    }
  }
})

watch(
  () => route.fullPath,
  () => {
    fireNaverPageview();
  }, // 페이지별 조회수 집계
);


// 팝업 body에 스크롤 막는 기능
watch(isAnyPopupOpen, (newVal) => {
	if (import.meta.client) {
    if (newVal) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden'

      // safari 화면 밀림 방지
      if (!CSS.supports('scrollbar-gutter', 'stable') && scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
    } else {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
	}
})


// 현재 사용자의 위치와 admin 팝업 경로를 비교해 화면에 띄어야할 팝업 선별
const visibleAdminPopups = computed(() => {
  return adminPopups.value.filter(popup => {
    // 이미 닫힌 팝업은 제외
    if (!isAdminVisible(popup.id)) return false

    // showOnPaths 설정이 없거나 비어있으면 모든 페이지 노출
    if (!popup.showOnPaths || popup.showOnPaths.length === 0) return true

    // 현재 경로가 허용된 경로 리스트에 포함되어 있는지 확인
    return popup.showOnPaths.includes(route.path)
  })
})

// 필터링 된 admin 팝업이 1개 이상일 경우 딤드 보여줌
const shouldShowAdminDimmed = computed(() => {
  return visibleAdminPopups.value.length > 0
})

// admin 팝업 아래 html 스크롤 되지 않도록 적용
watch(shouldShowAdminDimmed, (val) => {
  if (import.meta.client) {
    if (val) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.body.style.overflow = 'hidden'

      // safari 화면 밀림 방지
      if (!CSS.supports('scrollbar-gutter', 'stable') && scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`
      }
    } else {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
  }
})

// ##############################################################################################
// 팝업 조회 관련

const fetchBuilder  = useHconFetchBuilder()
const { showAlert } = usePopup()

interface popupDto {
  pupSeq: string          /* 팝업순번 */
  hcPupKndCd: string      /* HCON팝업종류코드 */
  pupTtl: string          /* 팝업제목 */
  pupHtmlCntn: string     /* 팝업HTML내용 */
  pupHztlLen: number      /* 팝업가로길이 */
  pupVtclLen: number      /* 팝업세로길이 */
  pupImgPath: string      /* 팝업이미지경로 */
  pupExpsPageUrl: string  /* 팝업노출페이지URL */
  pupLndgPageUrl: string  /* 팝업랜딩페이지URL */
}

// 팝업 목록 조회
const getPopupList = async () => {
  const fetchBuilderResult = 
  fetchBuilder.get<AjaxResult<popupDto[]>>('/api/v1/product/popup/list')
    .build()
    .execute()
    .then((res: any) => {
        if(res.resultCode != '200') {
            showAlert({
              title: '알림',
              message: res.resultMessage,
              confirmText: '확인'
            })
        } else {
          // 팝업정보 세팅
          const dataMap = transformPopupData(res.data)
          setAdminPopups(dataMap)
        }
    })
    .catch(err => {
      showAlert(err.resultMessage)
    })
}

const transformPopupData = (resData: popupDto[]) => {
  return resData.map((item) => {

    // 공통 속성 추출
    const common = {
      id: item.pupSeq,
      width: item.pupHztlLen,
      height: item.pupVtclLen,
      close: true,
      showOnPaths: [item.pupExpsPageUrl]
    }

    if(item.hcPupKndCd === "1001") {
      return {
        ...common,
        content: '<a href="'+ item.pupLndgPageUrl +'"><img src="' + cu.getFileFullUrl(item.pupImgPath, true)  + '" alt="" /></a>',
        adClass: 'no-header'
      }
    } else {
      return {
        ...common,
        content: item.pupHtmlCntn
      }
    }
  })
}

// ##############################################################################################
onBeforeMount(() => {
  window.addEventListener('session-storage-synced', handleAfterSessionSynced)
})
onMounted(() => {
  fireNaverPageview(); // 최초 진입시

  if (!route.path.startsWith('/view')) { // 브릿지 페이지에서는 팝업 목록 조회 호출되지 않도록 수정
    getPopupList() // 팝업 목록 조회
  }
  SessionStorageSynchronizer.init();
  // const authInfo  = useHconAuthInfo().getIfPossible();
  // const userContext = authInfo?.userContext
  // watch(() => useHconAuthInfo().getIfPossible()?.userContext, 
  //   (newV) => {
  //       isLoggedIn.value = !newV;
  //   }, { immediate : true}
  // )
})

onBeforeUnmount(() => {
  window.removeEventListener('session-storage-synced', handleAfterSessionSynced)
})

const handleAfterSessionSynced = async () => {
  const authInfo = sessionStorage.getItem('common.auth.info')
  const rememberMeToken = sessionStorage.getItem('common.auth.rememberMe')

  if (authInfo && rememberMeToken) {
    const rememberMeToken = localStorage.getItem('common.auth.isRememberMe') == 'N' ? null : SessionStorageSynchronizer.getItem('common.auth.rememberMe');

    if (rememberMeToken != null) {
        try {
            const res = await $fetch.raw<AjaxResult<any>>('/api/v1/member/auth/auto-login', {
                baseURL: useHconConfig().api.baseUrl,
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Remember-Me': rememberMeToken,
                },
            });
            isLoggedIn.value = true;
            useHconAuthInfo().setFromFetch(res);
            return;
        } catch (error) {
            console.error('auto-login fail', error);
        }
    }
    return;
  }
}
</script>

<style>
</style>
